"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPriceLayout = exports.StyledInstantIcon = exports.StyledIconsLayout = exports.StyledHotIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Hot = _interopRequireDefault(require("../../icons-react/rebrand/Hot"));
var _Instant = _interopRequireDefault(require("../../icons-react/rebrand/Instant"));
var _Button = _interopRequireDefault(require("../Button"));
var _HotelOfferPrice = _interopRequireDefault(require("../HotelOfferPrice"));
var _excluded = ["price", "hotPrice", "instantConfirm", "onClick", "isActive", "subtext"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelOfferButton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var price = _ref.price,
    hotPrice = _ref.hotPrice,
    instantConfirm = _ref.instantConfirm,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    subtext = _ref.subtext,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var count = [hotPrice, instantConfirm].filter(Boolean).length;
  var tripleStickersLayout = count === 3;
  var doubleStickersLayout = count === 2;
  var leftToRight = hotPrice && instantConfirm;
  var classNames = [tripleStickersLayout && 'triple', doubleStickersLayout && leftToRight && 'left-to-right', doubleStickersLayout && rightToLeft && 'right-to-left'].filter(Boolean).join(' ');
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferButton, (0, _extends2["default"])({
    size: "none",
    $isActive: isActive,
    onClick: onClick
  }, rest), /*#__PURE__*/_react["default"].createElement(StyledPriceLayout, null, /*#__PURE__*/_react["default"].createElement(_HotelOfferPrice["default"], {
    price: price
  }, !!count && /*#__PURE__*/_react["default"].createElement(StyledIconsLayout, {
    className: classNames
  }, hotPrice && /*#__PURE__*/_react["default"].createElement(StyledHotIcon, {
    $isActive: isActive
  }), instantConfirm && /*#__PURE__*/_react["default"].createElement(StyledInstantIcon, {
    $isActive: isActive
  }))), subtext && /*#__PURE__*/_react["default"].createElement(StyledSubText, null, subtext)));
});
HotelOfferButton.defaultProps = {
  hotPrice: false,
  instantConfirm: false,
  isActive: false,
  cancellationPolicy: null,
  subtext: ''
};
HotelOfferButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  price: _propTypes["default"].number.isRequired,
  hotPrice: _propTypes["default"].bool,
  instantConfirm: _propTypes["default"].bool,
  cancellationPolicy: _propTypes["default"].shape({
    kind: _propTypes["default"].string.isRequired,
    description: _propTypes["default"].string.isRequired
  }),
  isActive: _propTypes["default"].bool,
  subtext: _propTypes["default"].string
};
var StyledIconsLayout = exports.StyledIconsLayout = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledIconsLayout",
  componentId: "sc-161lx2c-0"
})(["display:flex;justify-content:center;gap:2px;"]);
var StyledPriceLayout = exports.StyledPriceLayout = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledPriceLayout",
  componentId: "sc-161lx2c-1"
})(["flex-grow:1;"]);
var IconStyle = (0, _styledComponents.css)(["height:22px;.triple &,.right-to-left &,.left-to-right &{height:14px;}"]);
var StyledHotIcon = exports.StyledHotIcon = (0, _styledComponents["default"])(_Hot["default"]).withConfig({
  displayName: "HotelOfferButton__StyledHotIcon",
  componentId: "sc-161lx2c-2"
})(["", " ", ";"], IconStyle, function (_ref2) {
  var $isActive = _ref2.$isActive;
  return $isActive ? (0, _styledComponents.css)(["path{fill:var(--secondary-color);}"]) : (0, _styledComponents.css)(["path{fill:var(--secondary);}"]);
});
var StyledInstantIcon = exports.StyledInstantIcon = (0, _styledComponents["default"])(_Instant["default"]).withConfig({
  displayName: "HotelOfferButton__StyledInstantIcon",
  componentId: "sc-161lx2c-3"
})(["", " ", ";"], IconStyle, function (_ref3) {
  var $isActive = _ref3.$isActive;
  return $isActive ? (0, _styledComponents.css)(["path{fill:var(--secondary-color);}"]) : (0, _styledComponents.css)(["path{fill:var(--secondary);}"]);
});
var StyledSubText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferButton__StyledSubText",
  componentId: "sc-161lx2c-4"
})(["font-size:12px;font-style:normal;font-weight:400;line-height:14px;white-space:pre;"]);
var StyledHotelOfferButton = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelOfferButton__StyledHotelOfferButton",
  componentId: "sc-161lx2c-5"
})(["display:flex;align-items:center;width:100%;padding:4px 0;font-family:'ONYOneFont','Helvetica',sans-serif;border-radius:var(--border-radius);--background-color:var(--background);background-color:var(--background-color);color:var(--black);margin-bottom:4px;", ";:hover{background:linear-gradient( 0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100% ),var(--background-color);}:active{background:linear-gradient( 0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100% ),var(--background-color);}"], function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive && (0, _styledComponents.css)(["--background-color:var(--secondary);color:var(--secondary-color);"]);
});
HotelOfferButton.HotelOfferPrice = _HotelOfferPrice["default"];
HotelOfferButton.displayName = 'HotelOfferButton';
var _default = exports["default"] = HotelOfferButton;